var React = require('react');

function AddIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 1 1 0 15zM7.5.938c-1.74 0-3.41.691-4.641 1.922A6.56 6.56 0 0 0 .938 7.5c0 1.74.691 3.409 1.922 4.641a6.56 6.56 0 0 0 4.641 1.922c1.741 0 3.409-.691 4.641-1.922a6.56 6.56 0 0 0-.002-9.279A6.57 6.57 0 0 0 7.5.938zm3.281 7.031H4.219A.47.47 0 0 1 3.75 7.5a.47.47 0 0 1 .469-.469h6.563a.47.47 0 0 1 .469.469.47.47 0 0 1-.469.469z","key":0}),React.createElement("path",{"d":"M7.5 11.25a.47.47 0 0 1-.469-.469V4.219A.47.47 0 0 1 7.5 3.75a.47.47 0 0 1 .469.469v6.563a.47.47 0 0 1-.469.469z","key":1})]);
}

AddIconInline.defaultProps = {"width":"15","height":"15","fill":"#269c74","fillRule":"evenodd","xmlnsV":"https://vecta.io/nano"};

module.exports = AddIconInline;

AddIconInline.default = AddIconInline;
